import { Handle, Node, NodeProps, Position } from '@xyflow/react';
import { useSetAtom } from 'jotai';
import { FC, useCallback } from 'react';

import { IconSvg } from '@/lib/v2/components';
import { DEFAULT_HANDLE_STYLE } from '@/lib/v3/components/Flows/CommonFlowCard';

import {
  atomNodeIdSelected,
  atomSidePanelIsOpen,
} from '@/src/modules/AutomationModuleNew/atoms/flows';
import { ConditionIcon } from '@/src/modules/AutomationModuleNew/components/Flows/icons';
import {
  SOURCE_HANDLE_NO,
  SOURCE_HANDLE_YES,
} from '@/src/modules/AutomationModuleNew/constants/flows';

import './styles.tailwind.css';

import { ConditionalNodeData } from '@/modules/AutomationModuleNew/types/flowsTypes';

type ConditionalNodeProps = NodeProps<Node<ConditionalNodeData>>;

export const ConditionalNode: FC<ConditionalNodeProps> = (props) => {
  const { data, id: nodeId } = props;
  const setNodeIdSelected = useSetAtom(atomNodeIdSelected);
  const setSidePanelIsOpen = useSetAtom(atomSidePanelIsOpen);

  const handleOpenSidePanel = useCallback(() => {
    setNodeIdSelected(nodeId);
    setSidePanelIsOpen(true);
  }, [nodeId, setNodeIdSelected, setSidePanelIsOpen]);

  if (data.type !== 'binaryConditional') return null;
  const { condition } = data.input;

  return (
    <div
      className="flex size-[45px] items-center justify-center rounded-lg border border-[#D3D3D3] bg-emblue-white p-2"
      id={nodeId}
      role="button"
      style={{ pointerEvents: 'all' }}
      tabIndex={0}
      onClick={handleOpenSidePanel}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          return false;
        }
      }}
    >
      <Handle position={Position.Top} style={{ ...DEFAULT_HANDLE_STYLE }} type="target" />
      <IconSvg height="24px" svgComponent={<ConditionIcon />} width="24px" />
      <Handle
        id={SOURCE_HANDLE_YES}
        position={Position.Right}
        style={{ ...DEFAULT_HANDLE_STYLE }}
        type="source"
      />
      <Handle
        id={SOURCE_HANDLE_NO}
        position={Position.Left}
        style={{ ...DEFAULT_HANDLE_STYLE }}
        type="source"
      />
    </div>
  );
};
